import { Post, Delete } from "./helpers";
import { ChannelCustomizedIcon } from "../types/working-model";

//insert the new custom icon into the database table channel_icons
export function CreateNewIcon(
	token: string,
	icon: ChannelCustomizedIcon
): Promise<{ uuid: string }> {
	return Post(`/v3/admin/channel-icons`, token, icon);
}

export function DeleteIcon(token: string, iconUuid: string): Promise<any> {
	return Delete(`/v3/admin/channel-icons/delete-icon/${iconUuid}`, token);
}
